module.exports = __webpack_public_path__ + "img/foot6.7c389faa.png";